import React, {useState} from 'react'
import AppointmentService from '../../../../../services/api/appointment.service'
import PracticeLocationRoomForm from '../location-room-form/PracticeLocationRoomForm'
import APIResponse from '../../../../templates/components/APIResponse';
import DimLoader from '../../../../templates/components/DimLoader';

const PracticeLocationRoomEdit = (props) => {
    const [locationFormData, setLocationFormData] = useState(props?.initialData || {})
    const [apiResponse, setApiResponse] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
      }

    const submitHandler=(data)=>{
        setIsLoader(true)
        const reqObj ={
            room:data?.room,
            practiceLocationRoomId: data?.practiceLocationRoomId,
            practiceLocationId: data?.practiceLocationId
        }
  
        AppointmentService.editPracticeLocationRoom(reqObj,data.practiceLocationRoomId)
        .then(res => {
            setApiResponse(res);
        }).catch(err =>{
            setApiResponse(err);
        }).finally(() => {
            setIsLoader(false)
        });
    }
    return(
        <>
            {isLoader && <DimLoader />}
            <PracticeLocationRoomForm submitHandler={submitHandler} initialFormData={locationFormData} onClose={() => props.onClose()} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default PracticeLocationRoomEdit